import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  tabsWrapper: {
    borderBottom: "none",
    borderColor: "divider",
    position: "absolute",
  },
  hiddenTab: {
    display: "hidden",
    width: "5rem",
  },
  tabsHeader: {
    position: 'fixed',
    top: '77px'
  },
  tabsHeaderContainer: {
    bottom: '38%',
    position: 'absolute',
    transition: 'left 0.3s',
  }
});
